<template>
  <Content id="users">
    <div slot="search">
      <Form :label-width="70" :model="search" id="searchForm">
        <Row>
          <Col>
            <FormItem label="体检任务" :label-width="75">
              <el-select v-model.trim="search.taskId" placeholder="体检任务"
                         clearable filterable size="small" transfer="true"
                         :popper-append-to-body="false" style="width: 250px;">
                <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleTaskChange(item)" style="width:250px;z-index: 9999;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="学校名称"  prop="schoolId" :label-width="75">
              <el-select v-model.trim="search.schoolId" placeholder="学校名称"
                         clearable filterable size="small" transfer="true"
                         :popper-append-to-body="false" style="width: 250px;" @change="changeSchool">
                <el-option v-for="item in schoolsList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleShoolChange(item)" style="width:250px;z-index: 9999;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="年级"  prop="gradeId" :label-width="45">
              <el-select v-model.trim="search.gradeId" placeholder="年级" clearable filterable size="small" transfer="true"
                         :popper-append-to-body="false" style="width: 100%" @change="changeGrade">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleGradeChange(item)"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="班级"  prop="classesId" :label-width="45">
              <el-select v-model.trim="search.classesId" placeholder="班级"
                         clearable filterable size="small" transfer="true"
                         style="width: 100%" :popper-append-to-body="false">
                <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleClassChange(item)"/>
              </el-select>
            </FormItem>
          </Col>
          <Col><FormItem label="姓名" :label-width="45"><el-input v-model="search.name" maxlength="50"/></FormItem></Col>
          <Col><FormItem label="条形码" :label-width="60"><el-input v-model="search.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem></Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>


    <el-card shadow="always" v-if="dataList&&dataList.length > 0">
      <div slot="header" class="clearfix">
        <span class="inspection_head_label_left">总人数:</span>
        <span class="inspection_head_text">{{ list.data.totalNumber }}</span>
        <span  class="inspection_head_label_right">体检人数:</span>
        <span class="inspection_head_text" >{{ list.data.physicalNumber }}</span>
      </div>
      <el-row :gutter="12">
        <el-col :span="8">
          <el-card shadow="hover" >
            <div class="inspection_item_box">
              <div>
                <span class="custom_progress_label">已检:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.checked,1)"  color="#f56c6c" text-color="#ffffff" :format="()=>{return this.list.data.checked}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">漏检:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.lack,1)" color="e6a23c" text-color="#ffffff" :format="()=>{return this.list.data.lack}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">未检:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.undetect,1)" color="5cb87a" text-color="#ffffff" :format="()=>{return this.list.data.undetect}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">请假:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.leave,1)"  color="#f56c6c" text-color="#ffffff" :format="()=>{return this.list.data.leave}"></el-progress>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div class="inspection_item_box">
              <div>
                <span class="custom_progress_label">正常收表:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.receiptForm,2)"  color="#f56c6c" text-color="#ffffff" :format="()=>{return this.list.data.receiptForm}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">异常收表:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.errorForm,2)" color="e6a23c" text-color="#ffffff" :format="()=>{return this.list.data.errorForm}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">未收表:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.unreceivedForm,2)" color="5cb87a" text-color="#ffffff" :format="()=>{return this.list.data.unreceivedForm}"></el-progress>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div slot="header" class="clearfix">
              <span  style="font-size: 13px;font-weight: 600;">检验单</span>
            </div>
            <div class="inspection_item_box">
              <div>
                <span class="custom_progress_label">已完成:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.completed,3)"  color="#f56c6c" text-color="#ffffff" :format="()=>{return this.list.data.completed}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">部分完成:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.partiallyCompleted,3)" color="e6a23c" text-color="#ffffff" :format="()=>{return this.list.data.partiallyCompleted}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">未完成:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.incomplete,3)" color="5cb87a" text-color="#ffffff" :format="()=>{return this.list.data.incomplete}"></el-progress>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div class="inspection_item_box">
              <div>
                <span class="custom_progress_label">缺漏项:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.missingItem,4)"  color="#f56c6c" text-color="#ffffff" :format="()=>{return this.list.data.missingItem}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">异常数据:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.abnormalData,4)" color="e6a23c" text-color="#ffffff" :format="()=>{return this.list.data.abnormalData}"></el-progress>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div class="inspection_item_box">
              <div>
                <span class="custom_progress_label">未审核:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.unaudited,4)"  color="#f56c6c" text-color="#ffffff" :format="()=>{return this.list.data.unaudited}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">已审核:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.audited,4)" color="e6a23c" text-color="#ffffff" :format="()=>{return this.list.data.audited}"></el-progress>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover">
            <div class="inspection_item_box">
              <div>
                <span class="custom_progress_label">已发布:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.published,5)"  color="#f56c6c" text-color="#ffffff" :format="()=>{return this.list.data.published}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">未发布:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.unPublished,5)" color="e6a23c" text-color="#ffffff" :format="()=>{return this.list.data.unPublished}"></el-progress>
              </div>
              <div>
                <span class="custom_progress_label">存在更新需重新发布:</span>
                <el-progress class="custom_progress" :text-inside="true" :stroke-width="20" :percentage="countProgress(this.list.data.republish,5)" color="5cb87a" text-color="#ffffff" :format="()=>{return this.list.data.republish}"></el-progress>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </Content>
</template>
<script>
import {_list} from "@/services/postScreening/generalInspection"
import {_gradesList, _classesList} from "@/services/studentManage/studentManage";
import {mixins} from "@/mixins";
export default {
  name: "GeneralInspection",
  mixins:[mixins],
  data() {
    return {
      search: {
        taskId: "",
        schoolId: "",
        gradeId: "",
        classesId: "",
        barCode: "",
        name: "",
      },
      schoolList: [],
      gradeList: [],
      classesList: [],
      dataList: [],
    };
  },
  async mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.initPage();
      await this.applyTaskList();
      await this.applySchoolsList();
      this.setSearchEle();
      this.handleDataList();
    }
  },
  methods: {
    setSearchEle() {
      this.searchElem=[
        {
          label: '条形码',
          labelWidth: 60,
          prop: "barCode",
          placeholder: "",
        },
        {
          label: '体检任务',
          labelWidth: 80,
          prop: "taskId",
          placeholder: "请选择学校",
          element:'select',
          events:'change',
        },
        {
          label: '学校',
          labelWidth: 60,
          prop: "schoolId",
          placeholder: "请选择学校",
          element:'select',
          events:'changeend',
          option: [...[ {label: '全部', value: ''}],...this.schoolsList]
        },
        {
          label: '年级',
          labelWidth: 60,
          prop: "gradeId",
          placeholder: "请选择年级",
          element:'select',
          events:'changeend',
          option:[...[ {label: '全部', value: ''}],...this.gradesList]
        },
        {
          label: '班级',
          labelWidth: 60,
          prop: "classesId",
          placeholder: "请选择班级",
          element:'select',
          events:'changeend',
          option:[...[ {label: '全部', value: ''}],...this.classesList]
        },
        {
          label: '姓名',
          labelWidth: 60,
          prop: "name",
          placeholder: "",
        },
      ]
    },
    query(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.handleDataList();
    },
    handleDataList() {
      _list({
        ...this.search,
      }).then(res => {
        this.dataList = res.data;
      }).catch(() => {});
    },
    changeSchool(schoolId) {
      if (!schoolId) {
        return;
      }
      _gradesList({schoolId: schoolId}).then(res => {
        this.search.schoolId = schoolId;
        this.search.gradeId = "";
        if (res.errcode === 1 && res.data) {
          this.gradeList = res.data;
        } else {
          this.gradeList = []
        }
      })
    },
    changeGrade(gradeId) {
      if (!gradeId) {
        return;
      }
      _classesList({schoolId: this.search.schoolId, gradeId: gradeId}).then(res => {
        this.search.gradeId = gradeId;
        this.search.classesId = "";
        if (res.errcode === 1 && res.data) {
          this.classesList = res.data;
        } else {
          this.classesList = []
        }
      })
    },
    handleTaskChange(item) {
      this.search.taskId = item.value;
    },
    handleShoolChange(item) {
      this.search.schoolId = item.value;
    },
    handleGradeChange(item) {
      this.search.gradeId = item.id;
    },
    handleClassChange(item) {
      this.search.classesId = item.id;
    },
    initPage(){
      this.dataList = {
        abnormalData:0,//异常数据
        audited:0,//已审核
        checked:0,//已检
        completed:0,//已完成
        errorForm:0,//异常收表
        incomplete:0,//未完成
        lack:0,//漏检
        leave:0,//请假
        missingItem:0,//缺漏项
        partiallyCompleted:0,//检验单部分完成
        physicalNumber:0,//体检人数
        published:0,//已发布
        receiptForm:0,//正常收表
        republish:0,//存在更新需重新发布
        totalNumber:0,//总人数
        unPublished:0,//未发布
        unaudited:0,//未审核
        undetect:0,//未检
        unreceivedForm:0,//未收表
      }
    },
    //计算比例
    countProgress(sub,type){
      let parent = 0;
      if (type === 1){
        parent = this.list.data.checked + this.list.data.lack+ this.list.data.leave+ this.list.data.undetect
      }
      if (type === 2){
        parent = this.list.data.receiptForm + this.list.data.errorForm+ this.list.data.unreceivedForm
      }
      if (type === 3){
        parent = this.list.data.completed + this.list.data.incomplete+ this.list.data.partiallyCompleted
      }
      if (type === 4){
        parent = this.list.data.abnormalData + this.list.data.missingItem
      }
      if (type === 5){
        parent = this.list.data.published + this.list.data.unPublished+ this.list.data.republish
      }
      if (!sub || parent ===0){
        return 0;
      }
      return sub/parent * 100;
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 5px;vertical-align: top;zoom: 1;}
.toolbar {
  margin-bottom: 24px;
  text-align: right;
  & .number {margin-right: 8px;}
}
.inspection_head_label_left{font-size: 16px;font-weight: 600;}
.inspection_head_label_right{margin-left: 20px;font-size: 16px;font-weight: 600;}
.inspection_head_text{margin-left: 5px;font-size: 14px;font-weight: 600;}
.inspection_item_box div{margin: 5px;}
.inspection_item_box .custom_progress_label{font-size: 13px;font-weight: 600;}
.inspection_item_box .custom_progress{margin-top: 3px;}

/deep/ .el-input__inner {height: 30px;line-height: 30px;}
/deep/ .el-input__icon{line-height: 30px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
</style>
